module.exports = __webpack_public_path__ + "3c38d87fd819a7e319aeb146371045cb.svg";